import {ContentBlocks_VideoTile as VideoTileType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/content_blocks.types';
import {ContentBlockVideo, RowSection} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {useContentBlockPromotionTracking} from '../helpers/useContentBlockPromotionTracking';
import {useTrackVideoPromotion} from '../helpers/useTrackVideoPromotion';
import {styleMap, transformVideo} from '../transforms';

export const VideoTile: React.FC<{
  content: VideoTileType;
  blockId?: number;
}> = ({content, blockId}) => {
  const {handleCTAClick, trackFeatureOnVideoEnds, videoElementRef} =
    useTrackContentBlock(content, blockId);

  return (
    <RowSection centerContent data-content-block={blockId}>
      <ContentWrapper>
        <ContentBlockVideo
          cta={
            content.cta && {
              link: content.cta.link,
              text: {
                style: styleMap[content.cta.text.style],
                text: content.cta.text.text,
                textColor: content.cta.text.color,
              },
            }
          }
          video={transformVideo(content.video)}
          onClickCTA={() => {
            if (content.cta) {
              handleCTAClick(content.cta.text.text, content.cta.link);
            }
          }}
          videoRef={videoElementRef}
          onEndVideoCallback={trackFeatureOnVideoEnds}
        />
      </ContentWrapper>
    </RowSection>
  );
};

const useTrackContentBlock = (content: VideoTileType, blockId?: number) => {
  const promotionTrackingClick = useContentBlockPromotionTracking();

  // using the fallback id for the promotionId since the double tile
  const promotionId = blockId ? String(blockId) : '';
  const promotionName = content.cta ? content.cta.text.text : '';
  const locationBlockType = 'videoTile';

  const {elementRef: videoElementRef, trackFeatureOnVideoEnds} =
    useTrackVideoPromotion({
      blockId,
      promotionName,
      promotionId,
      locationBlockType,
      path: {
        external: false,
        url: '',
      },
    });

  const handleCTAClick = (
    promotionName: string,
    path: {url: string; external: boolean},
  ) => {
    promotionTrackingClick({
      actionType: 'click',
      contentBlockSource: 'cta',
      locationBlockType,
      promotionId: blockId ? String(blockId) : '',
      blockId,
      promotionName,
      path,
    });
  };

  return {
    handleCTAClick,
    videoElementRef,
    trackFeatureOnVideoEnds,
  };
};

const ContentWrapper = styled.div`
  padding: 1rem;
  display: flex;
  flex-basis: 100%;
  max-width: 1440px;
`;
